import { useQuery } from '@apollo/client/react'
import { CreditCard } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { GQL_PAYMENT_FAILED } from '~/gql/billing/billing'
import BillingPortalButton from '~/pages/backoffice/admin/billing/BillingPortalButton'

/**
 * Le renouvellement n'a pas pu être encaissé et Stripe relance (`past_due`,
 * #354) : rappelé aux admins sur tout le back-office, avec de quoi changer de
 * carte. L'API dit quand l'afficher (jamais sur un compte géré). Le palier tient pendant les relances ; sans paiement au bout, l'espace
 * repasse en démo et un mail le dit.
 */
function PaymentFailedBanner() {
  const { t } = useTranslation()
  const { data } = useQuery(GQL_PAYMENT_FAILED, { fetchPolicy: 'cache-and-network' })
  if (!data?.billingAccount.paymentFailed) return null

  return (
    // Bouton sous le texte jusqu'à `md` compris, à sa droite au-delà.
    <div role="status" className="flex flex-col gap-3 rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-sm lg:flex-row lg:items-center">
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <CreditCard className="size-5 shrink-0 text-destructive" aria-hidden />
        <p>{t('billing.paymentFailed')}</p>
      </div>
      <div className="pl-8 lg:shrink-0 lg:pl-0">
        <BillingPortalButton variant="outline">{t('billing.paymentFailed.update')}</BillingPortalButton>
      </div>
    </div>
  )
}

export default PaymentFailedBanner
